module.exports = __webpack_public_path__ + "media/Goals/SaveMoney-88a44f4f.svg";